import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import useCategoryActions from "component/product/useCategoryActions";
import Dropdown from "component/react-bootstrap/Dropdown";
import Menu from "component/react-bootstrap/DropdownMenu";
import Toggle from "component/react-bootstrap/DropdownToggle";
import MenuItem from "component/react-bootstrap/MenuItem";
import { useState } from "react";
import { SortIcon } from "resources/svg-images/SortIcon";
import ProductFilterSortBy from "../product-filter-sortby.component";
import { sortNameConstant } from "../sortNameConstant";
import styles from "./sortFilterButton.module.scss";

export default function SortFilterButton(props) {
  const { url, appliedFilters } = props;
  const { onChangeSortBy } = useCategoryActions(url);
  const { sortBy } = appliedFilters;
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className={styles.sort_container}>
      <Dropdown
        open={isOpen}
        // componentClass={dropdownComponentClass}
        id="sort-filter-dropdown"
        onToggle={() => setIsOpen(!isOpen)}
      // pullRight={menuPullRight}
      >
        <Toggle
          aria-label="Garage Dropdown"
          className={`${styles.garage_dropdown} d-flex align-items-center justify-content-center`}
        >
          <div className={styles.sort}>
            <SortIcon />
            <PAText fontSize={FONT_SIZE[0]} color="grey-secondary" className="hidden-xs">
              Sort:
              {" "}
              {sortNameConstant[sortBy]}
            </PAText>

          </div>
        </Toggle>

        <Menu>
          {isOpen && (
            <MenuItem>
              <ProductFilterSortBy
                value={sortBy}
                onClick={onChangeSortBy}
              />

            </MenuItem>
          )}

        </Menu>
      </Dropdown>

    </div>
  );
}
